import React, { useState, useEffect } from "react";

const WatchAndDecide = () => {
  /* ---------------------------------------------------
     DATA & STATE
  --------------------------------------------------- */
  const questions = [
    {
      media: "https://bpc.h-cdn.co/assets/16/42/768x384/gallery-1476973978-travelmates-robotics.gif",
      prompt: "A robot Suitcase avoids furniture. Is this AI?",
      correct: "Yes",
      explanation: "✅ Yes! The Suitcase analyze the area and avoids obstacles using AI."
    },
    {
      media: "https://wiki.keyestudio.com/images/0/04/Traffic_light-2.gif",
      prompt: "A traffic light changes on a timer. Is this AI?",
      correct: "No",
      explanation: "❌ No! This light follows fixed rules, not smart decision-making."
    },
    {
      media: "https://www.ismartrecruit.com/assets/frontend/images/isr-learn_more-AI_&_Automation/Chat-Bot.gif",
      prompt: "A chatbot replies to a question. Is this AI?",
      correct: "Yes",
      explanation: "✅ Yes! Chatbots use AI to understand and respond to you."
    },
    {
      media: "https://www.ft.com/__origami/service/image/v2/images/raw/http%3A%2F%2Fcom.ft.imagepublish.upp-prod-eu.s3.amazonaws.com%2F1d91168c-8111-11e8-bc55-50daf11b720d?source=next-article&fit=scale-down&quality=highest&width=700&dpr=1",
      prompt: "A light turns on when you press a switch.",
      correct: "No",
      explanation: "❌ Nope! The Light is just following your command."
    },
    {
      media: "https://media.opennews.org/img/uploads/article_images/191009-wapo-autonomous-cars-image7-kangaroo-on-the-road.gif",
      prompt: "A self-driving car stops for a pedestrian. Is this AI?",
      correct: "Yes",
      explanation: "✅ Yes! Self-driving cars make smart decisions using AI sensors and models."
    }
  ];

  const [screen, setScreen] = useState("intro");
  const [current, setCurrent] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [showExplain, setShowExplain] = useState(false);
  const [savedMsg, setSavedMsg] = useState("");

  /* ---------------------------------------------------
     HELPERS
  --------------------------------------------------- */
  const resetQuestionState = () => {
    setFeedback("");
    setShowExplain(false);
    setSavedMsg("");
  };

  const handleAnswer = (choice) => {
    const correct = questions[current].correct;
    if (choice === correct) {
      setFeedback("🎉 Correct!");
    } else {
      setFeedback("❌ Oops! Try again next time.");
    }
    setShowExplain(true);
  };

  const handleSave = (text) => {
    if (text.trim() === "") {
      setSavedMsg("✋ Please type your reason before saving.");
    } else {
      console.log(`Q${current + 1}:`, text);
      setSavedMsg("✅ Saved!");
    }
  };

  const nextQuestion = () => {
    resetQuestionState();
    setCurrent((prev) => prev + 1);
  };

  /* ---------------------------------------------------
     STYLE OBJECTS
  --------------------------------------------------- */
  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: "linear-gradient(to bottom,rgb(253, 253, 253),rgb(148, 236, 248))",
      margin: 0,
      padding: 0,
      minHeight: "100vh"
    },
    container: {
      maxWidth: 900,
      margin: "0 auto",
      padding: "40px 20px",
      textAlign: "center"
    },
    title: {
      fontSize: "2.5rem",
      color: "#F06292",
      marginBottom: 30
    },
    bubble: {
      background: "#E1F5FE",
      borderRadius: 20,
      padding: 20,
      margin: "20px 0",
      fontSize: "1.2rem",
      boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
      position: "relative"
    },
    highlight: { color: "#D84315", fontWeight: "bold" },
    button: {
      display: "block",
      margin: "40px auto 0",
      padding: "14px 28px",
      fontSize: "1.2rem",
      background: "linear-gradient(to right, #4DD0E1, #7E57C2)",
      color: "#fff",
      border: "none",
      borderRadius: 14,
      cursor: "pointer",
      boxShadow: "2px 2px 10px rgba(0,0,0,0.2)"
    },
    gameHeader: {
      fontSize: "2rem",
      // background: "#FFAB91",
            // background: "rgb(194, 243, 216)",

      color: "#4E342E",
      padding: 20,
      margin: 0,
      textAlign: "center"
    },
    gameBox: {
      maxWidth: 650,
      margin: "30px auto",
      padding: 20,
      background: "#fff",
      borderRadius: 20,
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
      textAlign: "center"
    },
    media: {
      width: "90%",
      borderRadius: 12,
      border: "4px solidrgb(138, 252, 252)"
    },
    question: { fontSize: "1.2rem", color: "#D84315", margin: "15px 0" },
    btn: {
      fontSize: "1rem",
      padding: "10px 20px",
      margin: 5,
      background: "#64B5F6",
      color: "#fff",
      border: "none",
      borderRadius: 10,
      cursor: "pointer"
    },
    feedback: { fontWeight: "bold", fontSize: "1rem", marginTop: 10 },
    explanation: {
      background: "#E0F2F1",
      padding: 10,
      borderRadius: 10,
      fontSize: "0.95rem",
      margin: "10px auto",
      width: "90%"
    },
    textarea: {
      width: "90%",
      height: 80,
      fontSize: "1rem",
      padding: 10,
      marginTop: 10,
      borderRadius: 10,
      border: "2px solid #B2EBF2",
      resize: "none"
    },
    saveBtn: {
      background: "#81C784",
      marginTop: 10,
      fontSize: "1rem",
      padding: "8px 16px",
      border: "none",
      borderRadius: 10,
      cursor: "pointer"
    },
    nextBtn: {
      background: "#FFD54F",
      marginTop: 15,
      fontSize: "1rem",
      padding: "8px 16px",
      border: "none",
      borderRadius: 10,
      cursor: "pointer"
    },
    progressWrap: {
      display: "flex",
      justifyContent: "center",
      gap: 10,
      marginTop: 20
    },
    dot: (state) => ({
      width: 20,
      height: 20,
      borderRadius: "50%",
      background:
        state === "completed"
          ? "#81C784"
          : state === "active"
          ? "#4DB6AC"
          : "#ccc"
    }),
    endMsg: { fontSize: "1.3rem", color: "#2E7D32", padding: 20 }
  };

  /* ---------------------------------------------------
     RENDER HELPERS
  --------------------------------------------------- */
  const ProgressDots = () => (
    <div style={styles.progressWrap}>
      {questions.map((_, i) => (
        <div
          key={i}
          style={styles.dot(
            i < current ? "completed" : i === current ? "active" : "pending"
          )}
        />
      ))}
    </div>
  );

  const IntroScreen = () => (
    <div style={styles.container}>
      <div style={styles.title}>🎥 Activity 2: Watch & Decide!</div>

      {[
        "👀 Watch carefully! You'll see short clips of different machines or systems in action.",
        "🤖 Your challenge: After each clip, decide — ",
        "🧠 If the machine can learn or decide on its own, it's AI. If it just follows rules or repeats tasks, it's not!",
        "✅ You’ll click “Yes” or “No”, then get instant feedback with a short explanation.",
        "🎯 Let's see how well you spot smart machines!"
      ].map((t, idx) => (
        <div key={idx} style={styles.bubble}>
          {idx === 1 ? (
            <>
              🤖 Your challenge: After each clip, decide —{" "}
              <span style={styles.highlight}>Is this AI?</span>
            </>
          ) : (
            t
          )}
        </div>
      ))}

      <button style={styles.button} onClick={() => setScreen("game")}>
        👉 Start the Game
      </button>
    </div>
  );

  const GameScreen = () => {
    /* finished? */
    if (current >= questions.length) {
      return (
        <>
          <h1 style={styles.gameHeader}>🎥 Watch & Decide: Is This AI?</h1>
          <ProgressDots />
          <div style={styles.gameBox}>
            <div style={styles.endMsg}>
              🎉 You’ve completed the quiz! 🤖
            </div>
          </div>
        </>
      );
    }

    const q = questions[current];
    let userTextArea;

    return (
      <>
        <h3 style={styles.gameHeader}> Watch & Decide: Is This AI?</h3>
        <ProgressDots />
        <div style={styles.gameBox}>
          <img src={q.media} alt={`clip-${current}`} style={styles.media} />
          <div style={styles.question}>{q.prompt}</div>

          <div>
            {["Yes", "No"].map((c) => (
              <button
                key={c}
                style={styles.btn}
                onClick={() => handleAnswer(c)}
                disabled={showExplain}
              >
                {c}
              </button>
            ))}
          </div>

          {feedback && <div style={styles.feedback}>{feedback}</div>}
          {showExplain && (
            <>
              <div style={styles.explanation}>{q.explanation}</div>
              {/* <textarea
                ref={(el) => (userTextArea = el)}
                placeholder="💬 Why do YOU think it's AI or not?"
                style={styles.textarea}
              /> */}
              <div>
                
                {savedMsg && (
                  <div
                    style={{
                      fontSize: "0.9rem",
                      color: savedMsg.startsWith("✅") ? "green" : "red",
                      marginTop: 6
                    }}
                  >
                    {savedMsg}
                  </div>
                )}
              </div>
              <button style={styles.nextBtn} onClick={nextQuestion}>
                ➡️ Next
              </button>
            </>
          )}
        </div>
      </>
    );
  };

  /* ---------------------------------------------------
     MAIN RENDER
  --------------------------------------------------- */
  return <div style={styles.body}>{screen === "intro" ? <IntroScreen /> : <GameScreen />}</div>;
};

export default WatchAndDecide;
